import $ from "jquery";

interface VideoElements {
  video: HTMLVideoElement;
  timelineRoot: HTMLElement;
  trackElement: HTMLTrackElement;
}

const prepareVideoElements = (): VideoElements | null => {
  const video = $("#lecture_video")[0] as HTMLVideoElement | undefined;
  const timelineRoot = $("#lecture_timeline")[0] as HTMLElement | undefined;
  const trackElement = $("#lecture_track")[0] as HTMLTrackElement | undefined;
  if (!video || !timelineRoot || !trackElement) {
    return null;
  }
  return { video, timelineRoot, trackElement };
};

export { type VideoElements, prepareVideoElements };
